export const serviceFields = [
  { key: 'quantity', label: 'Quantity', required: true },
  { key: 'initialPrice', label: 'Initial Price', required: true },
  { key: 'initialDiscount', label: 'Initial Discount', required: true },
  { key: 'taxable', label: 'Taxable', required: true },
  { key: 'frequencyName', label: 'Frequency', required: true },

  { key: 'recurringPrice', label: 'Recurring Price', required: false },
  { key: 'recurringDiscount', label: 'Recurring Discount', required: false },
]

export const taxOptions = [
  { label: 'Y', value: 'Y' },
  { label: 'N', value: 'N' },
]

export const pendingLeads = 'pendingLeads'
